import React from 'react'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import InputLabel from '@material-ui/core/InputLabel'

// @material-ui/icons
import PermIdentity from '@material-ui/icons/PermIdentity'

// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import Button from 'components/CustomButtons/Button.jsx'
import CustomInput from 'components/CustomInput/CustomInput.jsx'
import Clearfix from 'components/Clearfix/Clearfix.jsx'
import Card from 'components/Card/Card.jsx'
import CardBody from 'components/Card/CardBody.jsx'
import CardHeader from 'components/Card/CardHeader.jsx'
import CardIcon from 'components/Card/CardIcon.jsx'

import styles from 'assets/jss/material-dashboard-pro-react/views/userProfileStyles'

// general api
import { insertOne, updateOne } from '../../services/generalServiceAPI'
import DropdownCompanies from '../Components/DropdownCompanies'
import * as Utility from '../utility/utility'
import swal from 'sweetalert'

class DepartmentProfile extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      text: {
        title: 'Create Department',
        button: 'Create'
      },
      data: {
        tableName: 'departments',
        id: '',
        name: '',
        description: '',
        companyId: ''
      },
      dataState: {
        name: ''
      },
      dirty: false
    }

    this.registerClick = this.registerClick.bind(this)
    this.handleDropdown = this.handleDropdown.bind(this)
    this.handleText = this.handleText.bind(this)
  }

  handleText(event) {
    // console.log(event.target)
    const { data, ...rest } = this.state
    this.setState({
      ...rest,
      data: { ...data, [event.target.id]: event.target.value },
      dirty: true
    })
  }
  handleDropdown = name => value => {
    // console.log(value)
    const { data, dataState, ...rest } = this.state
    data[`${name}Name`] = value.label
    data[`${name}Id`] = value.id
    dataState[name] = 'success'
    this.setState({
      ...rest,
      data,
      dataState,
      dirty: true
    })
  }

  registerClick() {
    if (this.state.data.name === '') {
      this.setState({ dataState: { name: 'error' } })
    }

    if (this.state.dirty) {
      if (Utility.noError(this.state.dataState)) {
        const insertOrModify = data => (data.id !== '' ? updateOne(data) : insertOne(data))
        const { tableName, ...rest } = this.state.data
        insertOrModify({ tableName, ...rest })
          .then(response => {
            // console.log(response)
            Utility.handleResponseOfSaving(response, this.props.refetch)
          })
          .catch(e => swal(`General API throw error: ${e}`))
      } else swal('Please fix the error on the page first.')
    }

    this.props.hideEditProfile()
  }

  componentDidMount() {
    if (this.props.data.id !== this.state.data.id)
      this.setState({
        text: {
          title: 'Update Department',
          button: 'Update'
        },
        data: {
          ...this.state.data,
          ...this.props.data,
          companyId: this.props.data.companyId
        }
      })
  }

  //<p>{JSON.stringify(this.state.data)}</p>
  render() {
    const { classes } = this.props

    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="rose" icon>
                <CardIcon color="rose">
                  <PermIdentity />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                  {this.state.text.title} <small />
                </h4>
              </CardHeader>
              <CardBody>
                <form>
                  {/**   name*/}
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={4}>
                      <CustomInput
                        success={this.state.dataState.nameState === 'success'}
                        error={this.state.dataState.nameState === 'error'}
                        labelText="Department Name"
                        id="name"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          disabled: false,
                          value: this.state.data.name,
                          onChange: event => this.handleText(event),
                          type: 'text'
                        }}
                      />
                    </GridItem>
                    {/* </GridContainer>
                  {/* affiliate */}
                    {/* <GridContainer> */}
                    <GridItem xs={12} sm={12} md={4}>
                      <DropdownCompanies
                        labelText="Company"
                        helperText="Please select a company"
                        id="companyId"
                        loose
                        formControlProps={{
                          fullWidth: true
                        }}
                        value={this.state.data.companyName}
                        onChange={this.handleDropdown('company')}
                      />
                    </GridItem>
                  </GridContainer>
                  {/* abot */}
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <InputLabel style={{ color: '#AAAAAA' }}>Briefs</InputLabel>
                      <CustomInput
                        // labelText="Anything you want to say about this company."
                        id="description"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          multiline: true,
                          value: this.state.data.description,
                          onChange: event => this.handleText(event),
                          rows: 5
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                  <Button color="rose" className={classes.updateProfileButton} onClick={this.registerClick}>
                    {this.state.text.button}
                  </Button>
                  <Clearfix />
                </form>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    )
  }
}

export default withStyles(styles)(DepartmentProfile)
